import { Injectable } from '@angular/core';

// <div style="font-family: verdana, geneva; font-size: 11pt;">

const NEW_ROW_MARKER = '<!-- {{insertNewRowHere}} -->';
const HTML_TEMPLATE = `
<!DOCTYPE html>
<html>
    <head>
    </head>
    <body>
        <h1>{{title}}</h1>
        <table>
            <!-- {{insertNewRowHere}} -->
        </table>
    </body>
</html>
`;
const TEXT_TEMPLATE = `
    {{title}}
    <!-- {{insertNewRowHere}} -->
`;

@Injectable({
    'providedIn': 'root'
})
export class EmailBuilderService {
    private htmlTemplate: string = HTML_TEMPLATE;
    private textTemplate: string = TEXT_TEMPLATE;

    // constructor() {
    // }

    public initializeEmailBody(): void {
        this.htmlTemplate = HTML_TEMPLATE;
        this.textTemplate = TEXT_TEMPLATE;
    }

    public setTitle(title: string): void {
        this.htmlTemplate = this.htmlTemplate.replace('{{title}}', title);
        this.textTemplate = this.textTemplate.replace('{{title}}', title);
    }

    public addRow(data: string, clickTracking = true): void {
        // his is the body. <a clicktracking='off' href='https://app.shuttlenomix.com'>https://app.shuttlenomix.com</a>",
        if (!clickTracking) {
            const pos = data.indexOf('<a ');
            if (pos >= 0) {
                const newdata = data.replace('<a ', '<a clicktracking=\'off\'');
                this.addHtmlRow(newdata);
                return;
            }
        }

        this.addHtmlRow(data);
        // this.addTextRow(data);
    }

    private addHtmlRow(data: string): void {
        // Style sheets, <div style="..."> don't work.
        // Inline styles work!
        const row =
            `
<tr>
    <td style="font-family: verdana, geneva; font-size: 11pt;">${data}</td>
</tr>
`;
        const pos = this.htmlTemplate.indexOf(NEW_ROW_MARKER);
        const left = this.htmlTemplate.substring(0, pos - 1);
        const right = this.htmlTemplate.substring(pos);
        this.htmlTemplate = left + row + right;
    }

    // private addTextRow(data: string): void {
    //     const row = data + '\n';
    //     const pos = this.textTemplate.indexOf(NEW_ROW_MARKER);
    //     const left = this.textTemplate.substring(0, pos-1);
    //     const right = this.textTemplate.substring(pos);
    //     this.textTemplate = left + row + right;
    // }

    public finalizeEmailBody(): void {
        this.htmlTemplate = this.htmlTemplate.replace(NEW_ROW_MARKER, '');
        this.textTemplate = this.textTemplate.replace(NEW_ROW_MARKER, '');
    }

    public getHtml(): string {
        return this.htmlTemplate;
    }

    public getText(): string {
        return this.textTemplate;
    }
}
